import Accordion from '@mui/material/Accordion';

export { Accordion };
